<main id="main" class="main">


  <section class="section dashboard">

    <div class="row">

      <form class="plansform">
        <div class="row">
          <div class="col-12 col-md-12 d-flex justify-content-between mb-0"
            style="background: #142a49!important; font-size:14px">
            <h6 class="admintitle my-auto">{{lang.Corporate_Customers}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
            </h6>
            <button class="addgroupadmininfoemp my-auto" (click)="addClientDetails()">+&nbsp;{{lang.Add_New}}</button>
          </div>




          <!-- <div class="row">
            <div class="row" class="filterByStatus">
              <div class="col-12 col-md-6 mt-1" style="position: absolute;">
                <label for="" style="font-size: 14px;font-family:'sans-serif';">{{lang.Filter_By_Status}}:&nbsp;</label>
              </div>
              <div class="col-md-6 p-0" style="position: absolute;">
                <select name="" id="" class="form-select form-select-sm filterSelect" (change)="changeStatus($event)">
                  <option value="all">{{lang.Select}}</option>
                  <option value="true">{{lang.Active}}</option>
                  <option value="false">{{lang.Inactive}}</option>

                </select>
              </div>
            </div>

          </div> -->

          <!-- <div style="display: flex; justify-content: space-between;" class="w-100 mb-1">
            <div class="mt-2 mx-1">
              <span>Show</span>
                <select [(ngModel)]="itemsPerPage" class="mx-1" [ngModelOptions]="{standalone: true}">
                    <option value="{{10}}">10</option>
                    <option value="{{25}}">25</option>
                    <option value="{{50}}">50</option>
                    <option value="{{100}}">100</option>
                </select>
                <span>entries</span>
            </div>
            <input class="form-control" style="width: auto;" placeholder="Search here..." [(ngModel)]="filterValue" [ngModelOptions]="{standalone: true}" />
          </div> -->


          <div class="table-responsive mt-2">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="DataTables_Table_0" style="background-color: #142a49 !important; color:black !important"
              class="table text-nowrap">
              <!-- <table
              class="table text-nowrap"> -->
              <thead>
                <tr>
                  <th>{{lang.Name??'Name'}}</th>
                  <th>{{lang.Broker_Advisor_Name??'Broker Advisor Name'}}</th>
                  <th>{{lang.Employee_profiles??'Broker profiles'}}</th>
                  <th>{{lang.Plan_Headcount??'Plan Headcount'}}</th>
                  <th>{{lang.Corporate_admin_email??'Corporate admin email'}}</th>
                  <th>{{lang?.Admin_Approved??'Admin Approved'}}</th>
                  <th>{{lang.Status??'Status'}}</th>
                  <th></th>
                  <th></th>

                  <!-- <th (click)="sortTable('name')" class="sorting">
                    {{lang.Name??'Name'}}
                    <i *ngIf="sortColumn === 'name'"
                      [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                      class="ms-2"></i>
                  </th>
                  <th (click)="sortTable('parentName')" class="sorting">
                    {{lang.Broker_Advisor_Name??'Broker Advisor Name'}}
                    <i *ngIf="sortColumn === 'parentName'"
                      [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                      class="ms-2"></i>
                  </th>
                  <th class="text-center" (click)="sortTable('customersCount')" class="sorting">
                    {{lang.Employee_profiles??'Broker profiles'}}
                    <i *ngIf="sortColumn === 'customersCount'"
                      [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                      class="ms-2"></i>
                  </th>
                  <th class="text-center" (click)="sortTable('bulkEmployeeCount')" class="sorting">
                    {{lang.Plan_Headcount??'Plan Headcount'}}
                    <i *ngIf="sortColumn === 'bulkEmployeeCount'"
                      [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                      class="ms-2"></i>
                  </th>
                  <th (click)="sortTable('email')" class="sorting">
                    {{lang.Corporate_admin_email??'Corporate admin email'}}
                    <i *ngIf="sortColumn === 'email'"
                      [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                      class="ms-2"></i>
                  </th>
                  <th (click)="sortTable('adminApproved')" class="sorting">
                    {{lang?.Admin_Approved??'Admin Approved'}}
                    <i *ngIf="sortColumn === 'adminApproved'"
                      [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                      class="ms-2"></i>
                  </th>
                  <th (click)="sortTable('published')" class="sorting">
                    {{lang.Status??'Status'}}
                    <i *ngIf="sortColumn === 'published'"
                      [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"
                      class="ms-2"></i>
                  </th>
                  <th></th>
                  <th></th> -->
                </tr>
              </thead>
              <tbody *ngIf="!restLoader; else loadingState">
                <tr *ngFor="let client of clientList; let i = index" class="my-auto"
                  [ngClass]="{'highlighted-row': selectedRow === i}">
                  <!-- <tr *ngFor="let client of filteredAndPaginatedCorporates; let i = index" class="my-auto"
                  [ngClass]="{'highlighted-row': selectedRow === i}"> -->

                  <!-- <td>{{i+1}}</td> -->
                  <!-- <td class="clientName" (click)="ShowDetails(client.id)">{{client.name}}</td> -->
                  <td (click)="viewBrokerDetails(client, i)" style="cursor: pointer;">

                    <span class="viewCorporate my-auto" [title]="client.name.length > 80 ? client.name : ''">
                      {{ client.name.length > 80 ? client.name.substring(0, 80) + '...' : client.name }}
                    </span>

                  </td>

                  <!-- <td class="text-captalize" (click)="viewBrokerDetails(client,i)" style="cursor: pointer;"><span  class="viewCorporate text-capitalize">{{client.name}}</span> </td> -->
                  <td class="my-auto">{{client.parentName}}</td>
                  <!-- <td>{{client.brokerType}}</td> -->
                  <td class="clientName text-center my-auto" (click)="ShowDetails(client,client.id)">
                    {{client.customersCount}}</td>

                  <td class="clientName text-center my-auto" data-bs-toggle="modal" data-bs-target="#showGroupPlansList"
                    (click)="ShowGroupPlansDetails(client,client.id)">
                    {{client.bulkEmployeeCount}} </td>

                  <!-- <td>{{client.customersCount}}</td> -->
                  <td class="my-auto">{{client.email}}</td>

                  <!-- <td> -->
                  <!-- <button class="brokertablestatus" *ngIf="client.status==false" style="color:red">Inactive</button>
          <button class="brokertablestatus" *ngIf="client.status==true" style="color:green">Active</button> -->
                  <td class="text-center">
                    <!-- {{client?.adminApproved?'Yes':'No'}} -->
                    <span *ngIf="client?.adminApproved" title="Yes"> <i class="fa fa-check" aria-hidden="true"
                        style="color:green"></i></span>
                    <span *ngIf="!client?.adminApproved" title="Approve">
                      <!-- <i class="fa fa-times" aria-hidden="true" style="color:red"></i> -->
                      <button class="addButton " (click)="adminApprove(client)">Approve</button>
                    </span>
                  </td>
                  <td>
                    <div style="display: flex;">
                      <div [style.color]="client.published ? 'green' : 'red'"
                        class="brokertablestatus text-center px-1">{{client.published ?
                        'Active':'Inactive'}}</div>
                      <!-- <div *ngIf="false" style="min-width: 20px; margin-left: 20px;" data-bs-target="showmemberlist">
                        <a class="viewicon" title="{{lang?.Terminate}}" data-toggle="tooltip" style="cursor: pointer;"><i
                            class="fa fa-trash-o pe-1" style="color:red; font-size:15px"
                            (click)="terminatemember(client,i)"></i></a>&nbsp;
                      </div> -->
                    </div>



                    <!-- <select class="form-control1 my-auto" id="gender" [(ngModel)]="client.status"
                      [ngModelOptions]="{standalone: true}" placeholder="Select"
                      (change)="brokerStatus(client,brokerstatus.value,i)" (click)="selectRow(i)" #brokerstatus>

                      <option value="true"> Active </option>
                      <option value="false"> Inactive </option>

                    </select> -->
                  </td>

                  <!--forms are empty corporate not able to add member  -->
                  <td class="d-flex my-auto justify-content-end ps-2 pe-2 gap-2"
                    *ngIf="client.formsLength>0; else noFormId">
                    <!-- *ngIf="client.forms.length>0; else noFormId"> -->
                    <!-- <a class="viewicon" title="View/Edit" data-toggle="tooltip" ><i class="fa fa-eye" (click)="viewBrokerDetails(client,i)"></i></a>&nbsp; -->
                    <!-- <a class="deleteicon" title="Delete" data-toggle="tooltip" ><i class="bi bi-trash-fill" *ngIf="role=='ADMINISTRATOR'" (click)="deletebrokerDetails(client,i)"></i></a>&nbsp; -->
                    <!-- <a class="deleteicon" title="Send Invite" data-toggle="tooltip" ><i class="fa fa-paper-plane" style="color: rgb(56,76,159);" *ngIf="role=='ADMINISTRATOR'" (click)="invitationbroker(client,i)"></i></a>&nbsp; -->
                    <button class="addButton " (click)="addEmployee(client)">{{lang.Add_member}}</button>

                  </td>
                  <td>
                    <!-- *ngIf="role=='ADMINISTRATOR'" -->
                    <a class="viewicon" title="Terminate" data-toggle="tooltip" style="cursor: pointer;"><i
                        class="fa fa-trash-o pe-1" style="color:red; font-size:15px"
                        (click)="terminateCorporate(client,i)"></i></a>&nbsp;
                    <a *ngIf="client.invitation" class="deleteicon" title="Send Invite" data-toggle="tooltip"><i
                        class="fa fa fa-send-o cursor: pointer;" style="color: rgb(56,76,159); cursor:pointer"
                        (click)="invitationCorporate(client,i)"></i></a>


                  </td>
                  <ng-template #noFormId>
                    <td></td>
                  </ng-template>

                </tr>
                <!-- <tr *ngIf="filteredAndPaginatedCorporates.length==0">
                  <td [colSpan]="9" class="text-center">No Data Available</td>
                </tr> -->
              </tbody>

              <ng-template #loadingState>
                <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" class="loader">
                  <td *ngFor="let j of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
                    <div class="is-loading">
                      <p></p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </table>
          </div>

          <!-- <div class="pagination mb-5">
            <span class="mx-2"></span>
            <button class="btn btn-primary" (click)="previousPage()" [disabled]="currentPage === 1">Previous</button>
            <span>Page {{currentPage}} of {{totalPages()}}</span>
            <button class="btn btn-primary" (click)="nextPage()" [disabled]="currentPage === totalPages()">Next</button>
          </div> -->
          <!-- <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="top" title="Tooltip on top"> Tooltip on top </button> <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="right" title="Tooltip on right"> Tooltip on right </button> <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tooltip on bottom"> Tooltip on bottom </button> <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="left" title="Tooltip on left"> Tooltip on left </button> -->

        </div>

      </form>

      <div class="row">
        <div class=" text-white text-left">
          <!-- <button class="btn btn-primary" id="backbuttonForm"
          type="button" (click)="gotoplansorwalletInfo()" style="float:left"><i aria-hidden="true" class="fa fa-long-arrow-left" ></i>&nbsp;&nbsp;Previous</button> -->

        </div>
        <div class=" text-white text-right">
          <!-- <button class="btn btn-primary" id="basicformSubmit" type="button" (click)="submitEmployeeInfoInfo()"> Save</button> -->
        </div>
      </div>



    </div>
  </section>
</main>



<div class="modal" id="subGroupList-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  aria-hidden="true">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title text-center">Sub Brokers List</span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>

      <div class="model-body" style="margin-top: 20px;">

        <div class="row">
          <div class="table-responsive">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger2" class="table text-nowrap">
              <thead>
                <tr>
                  <!-- <th>S.no</th> -->
                  <th>{{lang.Name}}</th>
                  <th>Role</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let broker of customerslist; let i = index">
                  <!-- <td>{{i+1}}</td> -->
                  <td>{{broker?.name}}</td>
                  <td>{{broker?.brokerType}}</td>

                  <td style="display:flex">
                    <a class="viewicon" title="View/Edit" data-toggle="tooltip"><i class="fa fa-eye"
                        (click)="viewBrokerCustomers(broker,i)"></i></a>&nbsp;&nbsp;
                    <!-- <a class="deleteicon" title="Delete" data-toggle="tooltip" ><i class="bi bi-trash-fill" (click)="deletebrokerDetails(broker,i)"></i></a>&nbsp;&nbsp; -->
                  </td>
                  <!-- <td></td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>




<div class="modal modal-xl fade" id="showmemberlist" aria-labelledby="exampleModalLabel" aria-hidden="true"
  style="max-width: 100% !important;">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title">{{lang.Employee_list_for}} <b>{{corporateCompany}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal" (click)="closelist()"></i>
      </div>
      <div class="model-body linescrollbar" style="overflow-y: auto;">
        <div class="row m-4">
          <div class="table-responsive">
            <label><strong><u>{{lang.Corporate_Account}}</u></strong></label>
            <table>
              <thead>
                <tr>
                  <th>{{lang.IGBMS_ID}}</th>
                  <th>{{lang.Name}}</th>
                  <!-- <th>Plan Admin</th> -->
                  <th>{{lang.Email}}</th>
                  <th>{{lang.Phone}}</th>
                  <th>{{lang.Status}}</th>
                  <!-- <th>PlanActivation Date</th>
                  <th></th> -->
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{corporateCustomerAccount?.fusebillId}}</td>
                  <td style="cursor: pointer;" (click)="viewBrokerDetailspopup()"><span
                      class="viewCorporate">{{corporateCustomerAccount?.firstName}}&nbsp;{{corporateCustomerAccount?.lastName}}</span>
                  </td>
                  <!-- <td></td> -->
                  <td>{{corporateCustomerAccount?.email}}</td>
                  <td>{{corporateCustomerAccount?.phoneNum}}</td>
                  <td *ngIf="corporateCustomerAccount">
                    {{corporateCustomerAccount?.corporateStatus ? "Active":"Inactive"}}
                  </td>
                  <!-- <td>{{corporateCustomerAccount?.planActivationDate | date}}</td>
                  <td style="display:flex">

                    <a class="deleteicon" title="Send Invite" data-toggle="tooltip"><i class="fa fa fa-send-o"
                        style="color: rgb(56,76,159);" *ngIf="role=='ADMINISTRATOR'"
                        (click)="invitationbroker(client,i)"></i></a>&nbsp;

                  </td> -->

                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row m-4">
          <div class="table-responsive">
            <label><strong><u>{{lang.Employee_List}}</u></strong></label>
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger1" id="DataTables_Table_1"
              class="table text-nowrap">
              <thead>
                <tr>
                  <!-- <th>S.no</th> -->
                  <th>{{lang.IGBMS_ID}}</th>
                  <th>{{lang.Name}}</th>
                  <th>{{lang.Email}}</th>
                  <th>{{lang.Phone}}</th>
                  <th>{{lang.Status}}</th>
                  <th>{{lang.Plan_activation_date}}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let client of employeelist; let i = index">
                  <!-- <td>{{i+1}}</td> -->
                  <td>{{client.fusebillId}}</td>
                  <td (click)="viewMemberDetails(client,i)" style="cursor: pointer;"><span
                      class="viewCorporate text-capitalize ">{{client.firstName}}&nbsp;{{client.lastName}}</span> </td>
                  <td>{{client.email}}</td>
                  <td>{{client.phoneNum}}</td>
                  <td>
                    {{client.status}}
                    <!-- <select class="form-control1" id="gender" style="width:100px" [(ngModel)]="client.status"
                      [ngModelOptions]="{standalone: true}" placeholder="client.status"
                      (change)="memberStatus(client,memberstatus.value,i)" #memberstatus>


                      <option value="Active"> Active </option>
                      <option value="Draft"> Draft </option>
                      <option value="Suspended"> Suspended </option>
                      <option value="Cancelled"> Cancelled </option>
                      <option value="Incomplete"> Incomplete </option>


                    </select> -->
                  </td>
                  <td>{{client.planActivationDate | date}}</td>
                  <td style="display:flex">

                    <!-- <a class="deleteicon" title="Delete" data-toggle="tooltip" ><i class="bi bi-trash-fill" *ngIf="role=='ADMINISTRATOR'" (click)="deletebrokerDetails(client,i)"></i></a>&nbsp; -->
                    <a *ngIf="(client.status=='Active' || client.status=='Draft') && (role==='ADMINISTRATOR' || role==='BROKER')"
                      class="viewicon ps-1" title="Terminate" data-toggle="tooltip" style="cursor: pointer;"><i
                        class="fa fa-trash-o" style="color:red; font-size:15px"
                        (click)="terminatemember(client,i)"></i></a>&nbsp;
                    <a *ngIf="client.bulkPlanIncluded!=true && client.status=='Active'" class="deleteicon"
                      title="Send Invite" data-toggle="tooltip"><i class="fa fa fa-send-o "
                        style="color: rgb(56,76,159); cursor: pointer;" *ngIf="role=='ADMINISTRATOR'"
                        (click)="invitationbroker(client,i)"></i></a>&nbsp;


                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <div class="modal-footer ">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closemodel (click)="closelist()">
          {{lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>


<div class="modal modal-lg fade" id="showGroupPlansList" style="max-width: 100% !important;">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title">{{lang.Group_Plans_list_for}} <b>{{corporateCompany1}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body linescrollbar" style="overflow-y: auto;">
        <div class="table-responsive m-4">
          <label><strong><u>Corporate Account</u></strong></label>
          <table>
            <thead>
              <tr>
                <th>{{lang.IGBMS_ID}}</th>
                <th>{{lang.Name}}</th>
                <th>{{lang.Email}}</th>
                <th>{{lang.Phone}}</th>
                <th>{{lang.Status}}</th>

              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{corporateCustomerAccount?.fusebillId}}</td>
                <td style="cursor: pointer;" (click)="viewBrokerDetailspopup()"><span
                    class="viewCorporate">{{corporateCustomerAccount?.firstName}}&nbsp;{{corporateCustomerAccount?.lastName}}</span>
                </td>
                <td>{{corporateCustomerAccount?.email}}</td>
                <td>{{corporateCustomerAccount?.phoneNum}}</td>
                <td>
                  {{corporateCustomerAccount?.corporateStatus?"Active":"Inactive"}}

                </td>


              </tr>
            </tbody>
          </table>

        </div>
        <div class="table-responsive m-4">
          <label><strong><u>{{lang.Bulk_Plan_Details}}</u></strong></label>
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger4" id="DataTables_Table_3">
            <thead>
              <tr>
                <th>{{lang.Name}}</th>
                <th>{{lang.Quantity}}</th>
                <th>{{lang.Status}}</th>
                <th>Activation Date</th>
                <th>Termination Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let plan of corporateBulkPlan ; let i = index">
                <td>{{plan?.planLevel}}</td>
                <td>{{plan?.quantity}}</td>
                <td>
                  {{plan?.status}}
                </td>
                <td>
                  {{plan.activationDate?.slice(0,10)}}
                </td>
                <td>
                  {{plan.terminationDate?.slice(0,10)}}
                </td>

              </tr>
            </tbody>

          </table>

        </div>
        <div class="table-responsive m-4">
          <div class="">
            <label><strong><u>Group Plan {{lang.Employee_list}}</u></strong></label>
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger3" id="DataTables_Table_2"
              class="table text-nowrap">
              <thead>
                <tr>
                  <!-- <th>S.No</th> -->
                  <th>{{lang.IGBMS_ID}}</th>
                  <th>{{lang.Name}}</th>
                  <th>{{lang.Email}}</th>
                  <th>{{lang.Phone}}</th>
                  <th>{{lang.Status}}</th>
                  <th>{{lang.Plan_activation_date}}</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let client of groupPlansList; let i = index">
                  <!-- <td>{{i+1}}</td> -->
                  <td>{{client.fusebillId}}</td>
                  <!-- (click)="viewMemberDetails(client,i)" -->
                  <!-- style="cursor: pointer;" -->
                  <td><span class="viewCorporate text-capitalize">{{client.firstName}}&nbsp;{{client.lastName}}</span>
                  </td>
                  <td>{{client.email}}</td>
                  <td>{{client.phoneNum}}</td>
                  <td>
                    <select class="form-control1" id="gender" style="width:100px" [(ngModel)]="client.status"
                      [ngModelOptions]="{standalone: true}" placeholder="client.status"
                      (change)="memberStatus(client,memberstatus.value,i)" #memberstatus>


                      <option value="Active"> {{lang.Active}} </option>
                      <option value="Draft"> {{lang.Draft}} </option>
                      <option value="Suspended"> {{lang.suspended}} </option>
                      <option value="Cancelled"> {{lang.Cancelled}} </option>
                      <option value="Incomplete"> {{lang.Incomplete}} </option>


                    </select>
                  </td>
                  <td>{{client.planActivationDate | date}}</td>


                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <div class="modal-footer ">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>


<div class="modal" id="showTerminateMemberDetailsCorpoarte" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-xl modal-dialog-centered " id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">

        <span class="modal-title py-2">{{lang.Terminate}}&nbsp;&nbsp;<b>{{corporateName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
          (click)="closelistCorporate()"></i>
      </div>
      <div class="modal-body" style="font-family: sans-serif; overflow-y: auto; overflow-x: hidden; max-height: 500px;">
        <form class="onboarding-form" [formGroup]="terminationformDetails">
          <!-- Table -->
            <div class="row" *ngIf="!showCorporateEmployees">
              <div class="col-12 col-md-6 pb-2">
                <div class="form-group mt-2">
                  <label for="parentidrole">{{ lang.Reason }}</label>
                  <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="reason"
                    data-live-search="true" aria-label="Select Reason">
                    <option value="" label="" disabled>{{ lang.Select }}</option>
                    <option *ngFor="let reason of terminateReasonsWithKeys" [value]="reason.key">
                      {{ reason.display }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          <div class="row m-4">
            <div class="table-responsive" *ngIf="terminateMemberDetails.length>0">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger5" id="DataTables_Table_4"
                class="table text-nowrap">
                <thead>
                  <tr>
                    <th class="my-auto" style="background: #5d7c9b !important;">
                      <input type="checkbox" (change)="toggleAllPlans($event)" aria-label="Select All Plans" />
                      &nbsp;IGBMS Id
                    </th>
                    <th class="my-auto" style="background: #5d7c9b !important;">Name</th>
                    <th style="background: #5d7c9b !important;">Enrollment Date</th>
                    <th class="text-center" style="background: #5d7c9b !important;">Amount</th>
                    <th style="background: #5d7c9b !important;">Date</th>
                    <!-- <th style="background: #5d7c9b !important;">Service</th> -->
                    <th style="background: #5d7c9b !important;">Broker</th>
                    <th style="background: #5d7c9b !important;">Form</th>
                    <th style="background: #5d7c9b !important;">Plans</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let terminateDetails of terminateMemberDetails; let i = index">
                    <td>
                      <input type="checkbox" id="planCheckbox{{terminateDetails.customerId}}"
                        [checked]="terminateDetails?.planCheckbox === true"
                        (change)="planCheckbox(terminateDetails.customerId, $event)"
                        aria-label="Select Plan {{terminateDetails.customerId}}" />
                      {{ terminateDetails?.staxbillDetails?.id }}
                    </td>
                    <td>{{ terminateDetails?.customerName }}</td>
                    <td>{{ terminateDetails?.enrollmentDate }}</td>
                    <td>
                      {{ terminateDetails?.monthlyRecurringAmount === 0 ? "$0" : "$" +
                      terminateDetails?.monthlyRecurringAmount }}
                    </td>
                    <td>{{ terminateDetails?.terminationDate }}</td>
                    <!-- <td>
                      {{ terminateDetails?.serviceType === 'NA' ? "N/A" : terminateDetails?.serviceType | titlecase }}
                    </td> -->
                    <td>
                      <select class="form-select border border-dark" name="broker" id="broker"
                        [(ngModel)]="terminateDetails.brokerId" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onBrokerChange($event, terminateDetails)" aria-label="Select Broker">
                        <option *ngFor="let broker of advisorBasedBrokers" [value]="broker.id">
                          {{ broker.name }} / {{ broker.salesTrackingCodeShare }}
                        </option>
                      </select>
                    </td>

                    <td>
                      <select class="form-select border border-dark" name="form" id="form"
                        [(ngModel)]="terminateDetails.formId" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onFormChange($event, terminateDetails)" aria-label="Select Form">
                        <option value="" disabled>Select</option>
                        <option *ngFor="let form of terminateDetails.forms" [value]="form.id">
                          {{ form?.formType }}-{{ form?.link }}
                        </option>
                      </select>
                    </td>

                    <td>
                      <a class="view-icon" title="View Plans" data-toggle="tooltip" style="cursor: pointer;"
                        (click)="viewPlansForEmployee(terminateDetails)" aria-label="View Plans">
                        <i class="fa fa-eye" style="color: blueviolet; font-size: 15px;"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Conditional Section -->

        </form>
      </div>

      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closelistCorporate()">
          {{lang.Cancel}}
        </button>
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton"
          [disabled]="!isAnyPlanCheckboxSelected()" (click)="submitterminationEndCorporate()"
          *ngIf="showCorporateEmployees">
          Proceed&nbsp;&nbsp;
        </button>
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton" [disabled]="terminationformDetails.invalid"
          *ngIf="!showCorporateEmployees" (click)="submitterminationEndCorporate()">
          {{lang.Terminate}}&nbsp;&nbsp;
        </button>

      </div>
    </div>
  </div>
</div>
<div class="modal" id="viewCorporateEmployeeplans" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-centered " id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">

        <span class="modal-title py-2">Plan Details of&nbsp;&nbsp;<b>{{customerName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body" style="font-family: sans-serif;">
        <form class="onbordingform" [formGroup]="terminationformDetails">



          <!-- table -->

          <div class="row m-4">
            <div class="table-responsive">
              <table class="table text-nowrap">
                <thead>
                  <tr>
                    <th class="my-auto" style="background: #5d7c9b !important; "> Name</th>
                    <th style="background: #5d7c9b !important; ">Coverage</th>
                    <th class="text-center" style="background: #5d7c9b !important; ">Price</th>
                    <th style="background: #5d7c9b !important; ">Tax</th>
                    <th style="background: #5d7c9b !important; ">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let plan of showCorporateEmployeeDetails; let i = index">

                    <td>{{plan?.name }}</td>
                    <td>{{ plan?.coverage}}</td>
                    <td>${{ plan?.price}}</td>
                    <td>${{ plan?.tax}}</td>
                    <td>${{ plan?.total}}</td>

                  </tr>
                  <tr *ngIf="showCorporateEmployeeDetails.length==0">
                    No Plans Found
                  </tr>
                </tbody>
              </table>

            </div>
          </div>

          <!-- *ngIf="terminateReasonsApplicable" -->


        </form>

      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeModelPopup('viewCorporateEmployeeplans')">
          {{lang.Close}}
        </button>


      </div>
    </div>
  </div>
</div>
<div class="modal" id="showTerminateMemberDetailsCorpoarteList" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-centered " id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">

        <span class="modal-title py-2">Convert&nbsp;&nbsp;<b>{{corporateName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body" style="font-family: sans-serif;    overflow-y: auto;
    overflow-x: hidden;
    max-height: 500px;">
        <form [formGroup]="employeeForm" style="padding:10px">
          <div formArrayName="employees">
            <div *ngFor="let employee of employees.controls; let i = index" [formGroupName]="i" class="employee-row">

              <div class="accordion" (click)="toggleAccordion(i)" [ngClass]="{'active': data1[i]?.isActive}">
                <button class="accordion-button">
                  {{ employee.get('customerName')?.value || 'Employee' }}
                  <span [ngClass]="data1[i]?.isActive ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"
                    style="float: right;"></span>
                </button>
              </div>
              <div class="panel" [ngStyle]="{'max-height': data1[i]?.isActive ? '300px' : '0'}"
                style="overflow: hidden; transition: max-height 0.3s ease;">
                <div class="row">

                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Name:</label>
                      <input formControlName="customerName" class="form-control" type="text" reareadonly />
                      <div *ngIf="employee.get('customerName')?.touched && employee.get('customerName')?.invalid"
                        class="help-block text-danger">
                        <div *ngIf="employee.get('customerName')?.errors?.['required']">
                          Enter Name
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Email:</label>
                      <input formControlName="email" id="email" class="form-control" type="text" />
                      <div *ngIf="employee.get('email')?.touched && employee.get('email')?.invalid"
                        class="help-block text-danger">
                        <div *ngIf="employee.get('email')?.errors?.['required']">
                          Enter Email
                        </div>
                        <div *ngIf="employee.get('email')?.hasError('pattern')">
                          Enter enter valid email
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Payment Method:</label>
                      <select formControlName="paymentMethod" class="form-control">
                        <option value="" disabled>Select</option>
                        <option value="credit_card">Credit Card</option>
                        <option value="PAD">PAD</option>

                      </select>
                      <div *ngIf="employee.get('paymentMethod')?.touched && employee.get('paymentMethod')?.invalid"
                        class="help-block text-danger">
                        <div *ngIf="employee.get('paymentMethod')?.errors?.['required']">
                          Select PaymentMethod
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Select Plans Status:</label>
                      <select formControlName="planSelection" class="form-control">
                        <option value="" disabled>Select</option>
                        <option *ngIf="employee.get('proceedWithEmpPaidPlans')?.value" value="proceedWithEmpPaidPlans" >Paid Plans</option>
                        <option *ngIf="employee.get('proceedWithCmpRelatedPlans')?.value" value="proceedWithCmpRelatedPlans" >Company Related Plans</option>
                        <option *ngIf="employee.get('proceedWithAllPlans')?.value" value="proceedWithAllPlans" >All Plans</option>
                        <option *ngIf="employee.get('proceedWithNoPlans')?.value" value="proceedWithNoPlans" >No Plans</option>


                      </select>
                      <div *ngIf="employee.get('planSelection')?.touched && employee.get('planSelection')?.invalid"
                        class="help-block text-danger">
                        <div *ngIf="employee.get('planSelection')?.errors?.['required']">
                          Select plan selection
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="row d-flex justify-content-end">
                  <div class="col-md-9"></div>
                        <div class="col-md-3">
                  <button class="btn btn-primary" (click)="showEmployeePlans(employee)">Show Plans</button>
                                </div>
                </div>
              </div>
            </div>




            <!-- <button type="button" (click)="removeEmployee(i)">Remove</button> -->

          </div>

          <!-- <button type="button" (click)="addEmployee1()">Add Employee</button> -->
          <!-- <button type="submit" [disabled]="employeeForm.invalid">Submit</button> -->
        </form>


      </div>
      <div class="modal-footer py-2">

        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeModelPopup('showTerminateMemberDetailsCorpoarteList')">
          {{lang.Cancel}}
        </button>

        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton"
          [disabled]="employeeForm.invalid" (click)="onSubmit()">
          {{lang.Submit}}&nbsp;&nbsp;
        </button>

      </div>
    </div>
  </div>
</div>
<div class="modal" id="showPlansForEmployee" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-centered " id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Plans</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">


        <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar"
          style="font-size: 12px; width:100%;max-height:350px;overflow-y: scroll;">
          <div *ngFor="let package of productsArray">
            <div class="plansscreen" *ngIf="isGroupsNotEmpty(package.groups)">
              <span style="color:black">{{package.name}}</span>
              <!-- <div class="wraptext"> -->

              <div class="row">
                <div class="column" *ngFor="let groups of package.groups | keyvalue">
                  <!-- <div *ngIf="group.plans.length>0"> -->
                  <div *ngFor="let group of package.groups[groups.key]">
                    <div *ngFor="let plan of group.plans; let i = index">
                      <div *ngIf="plan.insuranceType!='LIFE'">
                        <div class="card" *ngFor="let product of plan.productAddonssNames ; let j = index" title=""
                          [style.background-color]="
                        plan.isBundle==false?plan.productAddonss[product][0].planlevel.backgroundColor:group.backgroundColor">

                          <span class="card-header" style="color:white">{{product}}</span>
                          <div class="row" *ngFor="let coverage of plan.productAddonss[product]; let k = index">

                            <div class="col-md-6">
                              <input type="checkbox" [checked]="plancheckboxcheck==plan?.productAddonss[product][k].id"
                                id="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][k].planlevel.id }}"
                                class="plancheckbox{{ package.id }} plancv  newPlan{{plan.id}}  coverage{{coverage.planCoverageUI | uppercase}}"
                                attr.data="{{ package.name }}##{{ group.name }}##{{
                                  plan.planCoverage
                                }}##{{plan.productAddonss[product][k].calculatedTax?.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
                                  plan.frqMonthly
                                }}##{{ package.optIn }}##{{
                                  group.disallowedPlanLevels
                                }}##{{ group.parentId }}##{{ group.id }}##{{
                                  plan.name
                                }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{ group.disallowedPlanLevels }}"
                                (change)="
                                                                  onCheckboxChange(
                                                                    $event,
                                                                    package?.allowMultiple,
                                                                    plan.productAddonss[product][k].plan_level.disallowedPlanLevels,
                                                                    plan?.planOptions,
                                                                    group?.parentId,
                                                                    package?.name,
                                                                    group?.name,
                                                                    plan?.planCoverage,
                                                                    0,
                                                                    0,
                                                                    0,
                                                                    0,
                                                                    $event,
                                                                    i,
                                                                    j,
                                                                    k,
                                                                    plan,
                                                                    plan.productAddonss[product][k],package,group,coverage.planCoverageUI
                                                                  )
                                                                ">&nbsp;<span
                                style="color:white !important">{{coverage.planCoverageUI}}</span>
                            </div>
                            <div class="col-md-6">
                              <li class="plansCoverageDetails"><!---->
                                <span class="overflow-ellipsis2" style="float: right; color: white">
                                  {{ currencySymbol}}{{ coverage.price | number: "1.2-2"}}<small>*</small></span>
                                <span class="overflow-ellipsis" style="float: left; color: white"
                                  title={{coverage.planCoverageUI}}>



                                </span><span class="clearfix"></span>
                              </li>
                            </div>

                          </div>
                        </div>
                      </div>







                    </div>
                  </div>
                  <!-- </div> -->

                </div>
              </div>
            </div>
            <!-- </div> -->
          </div>
          <table *ngIf="notAllowedPlans.length>0">
              <label class="form-check-label ps-1 my-auto" for="filterMonth">
                Not Covered Plans
              </label>
            <thead>
              <th>Name</th>
              <th>Coverage</th>
              <th>Price</th>
              <th>Tax</th>
              <th>Total</th>
              </thead>
              <tbody>
                <tr *ngFor="let item of notAllowedPlans">
                  <td>{{item.productName}}</td>
                    <td>{{item.coverage}}</td>
                      <td>${{item.price}}</td>
                      <td>${{item.tax}}</td>
                      <td>${{item.total}}</td>
                </tr>
              </tbody>

          </table>
        </div>
        <!-- <div *ngIf="plansError" class="text-danger text-end" style="font-size:12px">
            {{lang.Please_select_atleast_one_plan}}
          </div> -->

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          {{lang.Close}}
        </button>

      </div>
    </div>
  </div>
</div>
<div class="modal" id="terminateConfirmDateModal" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title">{{lang.Terminate}}&nbsp;&nbsp;<b>{{corporateName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body">
        <form class="onbordingform" [formGroup]="terminationform">
          <div class="row">
            <div class="col-12 col-md-7">
              <div class="form-group">
                <label for="Corporation">{{lang.Please_choose_Termination_Date}}</label>
                <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field" id="terminationDate"
                  formControlName="terminationDate" [minDate]="minDate" bsDatepicker #dp placeholder="MM-DD-YYYY"
                  [bsConfig]="{showWeekNumbers: false}"
                  [(bsValue)]="myDateValue"  />
                <div class="help-block text-danger" *ngIf="terminationform.get('terminationDate')?.touched ">
                  <div *ngIf="terminationform.get('terminationDate')?.hasError('required') ||
                (terminationform.get('terminationDate')?.hasError('required'))"> {{lang.Please_Select_Date}}</div>

                </div>
              </div>
              <p *ngIf="role==='ADMINISTRATOR'" style="font-size:10px">Plan_enrollment_date_is-{{enroll
                |date:'MM-dd-yyyy'}}<br>{{note}}
              </p>
            </div>
          </div>
        </form>

      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeTerminatePopup('terminateConfirmDateModal')">
          {{lang.Close}}
        </button>
   <!-- <button class="text-end" type="submit" class="btn btn-primary personalinfobutton" (click)="submittermination()">
          {{lang.Submit}}&nbsp;&nbsp;
        </button> -->
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton" (click)="submittermination_v2()">
          {{lang.Submit}}&nbsp;&nbsp;
        </button>
        <!-- <button type="button" class="btn btn-secondary btn-light" id="updateButton" (click)="submittermination()" ><b>Submit</b></button>&nbsp;&nbsp; -->
 
      </div>
    </div>
  </div>
</div>

<div class="modal" id="terminateConfirmDateModalCorporate" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title">{{lang.Terminate}}&nbsp;&nbsp;<b>{{corporateName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body">
        <form class="onbordingform" [formGroup]="terminationform">
          <div class="row">
            <div class="col-12 col-md-7">
              <div class="form-group">
                <label for="Corporation">{{lang.Please_choose_Termination_Date}}</label>

                <input type="text" class="form-control " id="terminationDate" #dp
                  formControlName="terminationDate" [minDate]="minDate" bsDatepicker placeholder="MM-DD-YYYY"
                  [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
                  [(bsValue)]="myDateValue" (onNavigate)="onNavigate($event)"  />
                <div class="help-block text-danger" *ngIf="terminationform.get('terminationDate')?.touched ">
                  <div *ngIf="terminationform.get('terminationDate')?.hasError('required') ||
                (terminationform.get('terminationDate')?.hasError('required'))"> {{lang.Please_Select_Date}}</div>

                </div>
              </div>
              <!-- <p *ngIf="role==='ADMINISTRATOR'" style="font-size:10px">Plan_enrollment_date_is-{{enroll
                |date:'MM-dd-yyyy'}}<br>{{note}}
              </p> -->
            </div>
          </div>
        </form>

      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeTerminatePopup('terminateConfirmDateModal')">
          {{lang.Close}}
        </button>
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton"
          (click)="submitterminationCorporate()">
          {{lang.Submit}}&nbsp;&nbsp;
        </button>
        <!-- <button type="button" class="btn btn-secondary btn-light" id="updateButton" (click)="submittermination()" ><b>Submit</b></button>&nbsp;&nbsp; -->

      </div>
    </div>
  </div>
</div>

<!-- this is for below signup dependets payment info and subscrption -->
<!-- <div class="card-group"> -->


<div class="modal" id="memberdetails-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">

  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" style="width:1000px">
      <div class="modal-header text-center">
        <span class="modal-title text-center">{{lang.Member_Data}}</span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>

      <div class="model-body" *ngIf="showmemberData">
        <app-overview></app-overview>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- </div> -->

<!-- <app-update-address id="updateAddress" class="modal fade mt-5 modal-lg" data-bs-backdrop="static"  [addressform]="addressform" [formConfiguration]="formConfiguration"></app-update-address>
<app-update-phoneno id="updatePhoneNo" class="modal fade mt-5" data-bs-backdrop="static" [phoneform]="phoneform"></app-update-phoneno>
<app-update-spouseplan *ngIf="UpdateSpousePlanComponent" id="updateSpousePlan" class="modal fade mt-5 modal-lg" data-bs-backdrop="static" [spouseform]="spouseform" [formConfiguration]="formConfiguration"></app-update-spouseplan>
<app-update-dependent id="updateDependent" class="modal fade modal-lg" data-bs-backdrop="static" [dependentform]="dependentform" [childrenId]="childrenId" [formConfiguration]="formConfiguration"></app-update-dependent>
<app-invoice-details id="invoiceDetails" class="modal fade mt-3 modal-lg" data-bs-backdrop="static" [invoices]="invoicesList"></app-invoice-details>
<app-health-card id="hicDetails" class="modal fade mt-3 modal-lg" data-bs-backdrop="static" [hicList]="hicList"></app-health-card>
<app-health-plan id="hpbooklet" class="modal fade mt-3 modal-lg" data-bs-backdrop="static"></app-health-plan>
<app-record-enrollment id="roe" class="modal fade mt-3 modal-lg" data-bs-backdrop="static" [roelink]="roe"></app-record-enrollment>
<app-update-payment-method id="updatePaymentMethod" class="modal fade mt-3" data-bs-backdrop="static"></app-update-payment-method>
<app-update-payment-info id="updatePaymentInfo" class="modal fade mt-3" data-bs-backdrop="static"></app-update-payment-info> -->

<!-- Email Update Modal -->
<!-- <div id="updateEmail" class="modal fade modalposition" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" id="backgroundColor">
                <h6 class="modal-title">{{lang.emailUpdate}}</h6>
                <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
            </div>
            <div class="modal-body">
                <form>
                    <div class="row">
                        <div class="col-md-12 form-group">
                            <label id="modal-labels">{{lang.email_cp}}<span style="color: red">*</span></label>
                            <input type="text" id="email" formControlName="email" class="form-control"
                                (keypress)="(($event.charCode >= 65 && $event.charCode < 91)||($event.charCode >= 97 && $event.charCode < 123))">
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer py-2">
                <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal"
                    id="cancelButton"><b>{{lang.cancel}}</b></button>&nbsp;&nbsp;
                <button type="button" class="btn btn-sm btn-light" id="updateButton">{{lang.update_cp}}</button>
            </div>
        </div>
    </div>
</div> -->
<!-- <div class="modal" id="terminatemember" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title">Terminate<b>{{emplomentName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body">
        <form class="onbordingform" [formGroup]="terminationform">

          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Reason</label>

                <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="reason"
                  data-live-search="true">
                  <option value="" label="" disabled>Select</option>
                  <option value="AU" label="">Audit</option>

                </select>


              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Member Status</label>

                <select class="form-control select2" id="parentidrole" placeholder="Select"
                  formControlName="memberstatus" data-live-search="true">
                  <option value="" label="" disabled>Select</option>
                  <option value="N" label="">Not Deceased</option>
                  <option value="N" label="">Deceased</option>



                </select>


              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Termination Date</label>

                <input type="text" placeholder="MM-DD-YYYY" class="form-control checking-field"
                  formControlName="terminationDate" bsDatepicker [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" />


              </div>
            </div>
          </div>
        </form>

      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary btn-light" id="updateButton"
          (click)="submittermination()"><b>Submit</b></button>&nbsp;&nbsp;
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          Close
        </button>
      </div>
    </div>
  </div>
</div> -->





<app-header *ngIf="false" (selectedlanguage)="setlanguage($event)"></app-header>
<app-confirmation-dialog *ngIf="languageData" [message]="message" [isCorporate]="isCorporate"
  [checkboxes]="checkboxesForMail" [languageData]="languageData">
</app-confirmation-dialog>


<!-- <app-welcome-bar *ngIf="false" [fusebillId]="fusebillId"></app-welcome-bar> -->




<!-- <footer id="footer" class="footer">
    <div class="copyright">Version IB:{{version}}  © 2024 :
      <a class="text-reset fw-bold" href="https://www.groupbenefitz.ca/" target="-blank"> The GroupBenefitz Platform Inc.</a></div>
 </footer> -->
<a (click)="scrollTop()" class="back-to-top d-flex align-items-center justify-content-center"><i
    class="bi bi-arrow-up-short"></i></a>
<!-- <main id="main" class="main">
  <div class="mainScreen">
    <span>Work in Progress!</span>
  </div>
  </main> -->
<!-- <app-add-employee id="openModelAddMumber" [valuFormChaild]="valuFormChaild" [clientDetails]="clientDetails" class="modal">
  </app-add-employee> -->
<div class="modal modalposition modal-lg" data-bs-backdrop="static" id="showplanoptions12-modal" *ngIf="showoptions"
  style="max-width: 100%;">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" id="modal-dialog">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" id="backgroundColor">
        <span class="modal-title">{{lang.Choose_Options}}</span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
          (click)="closeoptionsselection()"></i>
      </div>
      <div class="model-body" style="max-width: 800px;

          overflow-y: scroll;">


        <!--  -->
        <input type="hidden" id="plandetailsobj" value="{{plandetailsobjvalue}}">
        <input type="hidden" id="optionumber" value="{{optionstitle.length}}">

        <div *ngFor="let option of optionstitle; let i = index" style="max-height: 350px;
            overflow-y: scroll;">
          <span></span>
          <span><b>{{option.name}}</b><span style="color: red">*</span></span>


          <div *ngFor="let optionvalue of option.planOptionsValues; let j = index">
            <div class="row">
              <div class="col-md-12" style="border: 1px solid black;padding:5px 15px;border-bottom:1px !important">
                <input type="radio" name="{{option.id}}" value="{{optionvalue.json}}"
                  id="planselectionvalue-{{optionvalue.id}}-{{option.id}}" class="optionselectionmethod-{{option.id}}"
                  class="optionselectionmethod-{{option.id}}"
                  (click)="planoptionselection($event,optionvalue,option.id,optionvalue.id)">&nbsp;{{optionvalue.name}}

              </div>
            </div>
          </div>
          <br>
        </div>

        <div class="modal-footer">
          <p id="planoptionmessage"><b>{{optionmessage}}</b></p>
          <button type="button" class="btn " data-bs-dismiss="modal" (click)="closeoptionsselection()"
            id="cancelButton"><b>{{lang.Close}}</b></button>
          <button type="button" class="btn btn-sm btn-light"
            (click)="confirmoptionsselection()"><b>{{lang.Confirm}}</b></button>
        </div>
      </div>


    </div>
  </div>
</div>

<div class="modal" id="showTerminateMemberDetails" aria-labelledby="exampleModalLabel" aria-hidden="true" *ngIf="terminateMemberDetails">
  <div class="modal-dialog modal-lg modal-dialog-centered " id="modal-dialog" style="font-family: sans-serif;">
    <div class="modal-content" id="modal-content">
 
      <div class="modal-header" id="backgroundColor">
        <span
          class="modal-title py-2">{{lang.Terminate}}&nbsp;&nbsp;<b>{{emplomentFirstName}}&nbsp;{{emplomentLastName}}</b></span>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
      </div>
      <div class="model-body" style="font-family: sans-serif;">
        <form class="onbordingform" [formGroup]="terminationformDetails">
 
          <div>
 
            <div class="row ">
              <div class="col-md-6 pt-2">
                <label>{{lang.Customer_Type}}: {{terminateMemberDetails?.customerType }}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.IGBMS_Id}}: {{terminateMemberDetails?.staxbillDetails?.id }}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Plan_Enrollment_Date}}: {{ terminateMemberDetails?.enrollmentDate}}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Termination_Date}}: {{terminateMemberDetails?.terminationDate}}</label>
              </div>
              <div class="col-md-6 pt-2">
                <label>{{lang.Service_Type}}:
                  {{terminateMemberDetails?.servicesType && terminateMemberDetails?.servicesType.length<=0 ? 'N/A' :
                    terminateMemberDetails?.servicesType?.join(', ') | titlecase}}</label>
                </div>
                <div class="col-md-6 pt-2">
                  <label>{{lang.Monthly_Premium}}:
                    {{terminateMemberDetails?.monthlyRecurringAmount==0?"$0":"$"+terminateMemberDetails?.monthlyRecurringAmount}}</label>
                </div>
 
              </div>
              <div class="row pt-2">
 
                <div class="col-md-12">
                  <label>{{lang.Refund_Details}}
                  </label>
                </div>
 
                <div *ngIf="!isDisabled()" class="col-md-6 pt-2 ">
                  <div>
                    <label> Refund Applicable<span class="text-danger">*</span></label>
                  </div>
 
                  <div class="form-check form-check-inline col-3">
                    <input class="form-check-input border border-dark" type="radio" name="proceedWithRefund"
                      id="proceedWithRefundYes" [value]=true formControlName="proceedWithRefund"  />
                    <label class="form-check-label" for="proceedWithRefundYes">
                      Yes</label>
                  </div>
                  <div class="form-check form-check-inline col-3">
                    <input class="form-check-input border border-dark" type="radio" [value]=false name="proceedWithRefund"
                      id="proceedWithRefundNo" formControlName="proceedWithRefund" />
                    <label class="form-check-label" for="proceedWithRefundNo">No</label>
                  </div>
 
 
                </div>
 
 
                <div *ngIf="isDisabled()" class="col-md-6 pt-2 ">
                  <div>
                    <label> Refund Applicable<span class="text-danger">*</span></label>
                  </div>
 
                  <div class="form-check form-check-inline col-3">
                    <input disabled class="form-check-input border border-dark" type="radio" name="proceedWithRefund"
                      id="proceedWithRefundYes" [value]=true formControlName="proceedWithRefund"  />
                    <label class="form-check-label" for="proceedWithRefundYes">
                      Yes</label>
                  </div>
                  <div class="form-check form-check-inline col-3">
                    <input disabled class="form-check-input border border-dark" type="radio" [value]=false name="proceedWithRefund"
                      id="proceedWithRefundNo" formControlName="proceedWithRefund" />
                    <label class="form-check-label" for="proceedWithRefundNo">No</label>
                  </div>
 
 
                </div>
 
 
 
                <div class="col-md-6 pt-2 ">
                  <label>{{lang.Refund_Applicable}}:
                      <input *ngIf="!isDisabled()" type="text" class="form-control border border-dark"
                      placeholder="Please enter actual refund amount" formControlName="refundAmount" />
 
                      <input *ngIf="isDisabled()" disabled type="text" class="form-control border border-dark"
                      placeholder="Please enter actual refund amount" formControlName="refundAmount" />
                    </label>
                </div>
 
                <!-- <div class="col-md-6 pt-2 ">
                  <label>Refund Applicabsle:
                    {{staxbillDetails?.refundApplicable==false?' No':'Yes'}}</label>
              </div> -->
              <div class="col-md-6 pt-2">
                <label>{{lang.Payment_Method}}:
                  {{terminateMemberDetails?.paymentMethod}}</label>
              </div>
              <!-- <div class="col-md-6 pt-2 ">
                  <label>{{lang.Refund_Actual_Amount}}:
                    {{staxbillDetails?.refundAmount=='NA'?"N/A":'$ ' +staxbillDetails?.refundAmount}}</label>
                </div> -->
              <div class="col-md-6 pt-2 ">
                <label>{{lang.Refund_Based_on_Payments}}:
                  $ {{terminateMemberDetails?.refundAmountbasedOnPayments}}</label>
              </div>
 
            </div>
          </div>
 
          <div class="row  px-2 mt-2" *ngIf="terminateMemberDetails?.invoiceAndRefunds && terminateMemberDetails?.invoiceAndRefunds.length>0">
 
            <table align="left">
              <tr>
                <th class="my-auto" style="background: #5d7c9b !important; ">{{lang.Invoice_Id}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Invoice_Number}}</th>
                <th class="text-center" style="background: #5d7c9b !important; ">{{lang.Amount}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Date}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Payment_Status}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Refund_Applicable}}</th>
              </tr>
              <tbody>
                <tr *ngFor="let invoice of terminateMemberDetails.invoiceAndRefunds">
                  <td>{{invoice.id}}</td>
                  <td>{{invoice.invoiceNumber}}</td>
                  <td class="text-center">$ {{invoice.invoiceAmount | number : "1.2-2"}}</td>
                  <td>{{invoice.postedTimestamp|date: 'MM-dd-YYYY'}}</td>
                  <td>{{invoice?.paymentStatus}}</td>
                  <td>{{invoice?.refundApplicable ===false?'No':'Yes'}}</td>
                </tr>
              </tbody>
            </table>
 
          </div>
 
 
          <!-- table -->
          <div class="row px-2 mt-2"
            *ngIf="terminateMemberDetails?.serviceType && terminateMemberDetails?.serviceType.length>0 && terminateMemberDetails?.terminationsProvisioning.length>0">
            <table align="left" style="background: #5d7c9b !important; ">
              <tr>
                <th class="my-auto" style="background: #5d7c9b !important; ">{{lang.Service}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Name}}</th>
                <th style="background: #5d7c9b !important; ">{{lang.Policy}}</th>
                <th style="width:175px ;background: #5d7c9b !important;">{{lang.Effective_Termination_Date}}</th>
                <th style="width:100px ;background: #5d7c9b !important;">{{lang.Membership_Id}}</th>
                <th style="width:200px ;background: #5d7c9b !important; ">{{lang.Action}}</th>
              </tr>
              <tbody>
 
                <tr class=" my-auto bg-white" *ngFor="let item of terminationsProvisioning ; let index=index">
                  <td>{{item?.serviceType}}</td>
                  <td>{{item?.service}}</td>
                  <td>{{item?.policy}}</td>
                  <td>{{item?.date}}<br><small>{{item.description}}</small></td>
                  <td>{{item?.membershipId}}</td>
                  <td>
 
                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showEquitable">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_Equitable}}<span class="text-danger">*</span></label>
                      </div>
 
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithEquitable"
                          id="proceedWithEquitableYes" [value]=true formControlName="proceedWithEquitable" />
                        <label class="form-check-label" for="proceedWithEquitableYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithEquitable" id="proceedWithEquitableNo"
                          formControlName="proceedWithEquitable" />
                        <label class="form-check-label" for="proceedWithEquitableNo">{{lang.No}}</label>
                      </div>
 
                    </div>
 
                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showSmartchoice">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_Smartchoice}}<span class="text-danger">*</span></label>
                      </div>
 
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithSmartchoice"
                          id="proceedWithSmartchoiceYes" [value]=true formControlName="proceedWithSmartchoice" />
                        <label class="form-check-label" for="proceedWithSmartchoiceYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithSmartchoice" id="proceedWithSmartchoiceNo"
                          formControlName="proceedWithSmartchoice" />
                        <label class="form-check-label" for="proceedWithSmartchoiceNo">{{lang.No}}</label>
                      </div>
 
                    </div>
                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showGreenshield">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_Greenshield}}<span class="text-danger">*</span></label>
                      </div>
 
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithGreenshield"
                          id="proceedWithGreenshieldYes" [value]=true [disabled]="!item?.membershipId"
                          formControlName="proceedWithGreenshield" />
                        <label class="form-check-label" for="proceedWithGreenshieldYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithGreenshield" [disabled]="!item?.membershipId" id="proceedWithGreenshieldNo"
                          formControlName="proceedWithGreenshield" />
                        <label class="form-check-label" for="proceedWithGreenshieldNo">{{lang.No}}</label>
                      </div>
 
                    </div>
                    <div class="form-group col-12 col-md-12" id="box" *ngIf="item?.showPHR">
                      <div class="col-12">
                        <label for=""> {{lang.Proceed_With_PHR}}<span class="text-danger">*</span></label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" name="proceedWithPHR"
                          id="proceedWithPHRYes" [value]=true [disabled]="!item?.membershipId"
                          formControlName="proceedWithPHR" />
                        <label class="form-check-label" for="proceedWithPHRYes">
                          {{lang.Yes}}</label>
                      </div>
                      <div class="form-check form-check-inline col-3">
                        <input class="form-check-input border border-dark" type="radio" [value]=false
                          name="proceedWithPHR" [disabled]="!item?.membershipId" id="proceedWithPHRNo"
                          formControlName="proceedWithPHR" />
                        <label class="form-check-label" for="proceedWithPHRNo">{{lang.No}}</label>
                      </div>
 
                    </div>
                  </td>
 
                </tr>
 
              </tbody>
 
            </table>
 
          </div>
 
          <div class="row" *ngIf="terminateReasonsApplicable">
            <div class="col-12 col-md-6 pb-2">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Reason}}</label>
 
                <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="reason"
                  data-live-search="true">
                  <option value="" label="" disabled>{{lang.Select}}</option>
                  <option value="" *ngFor="let reson of terminateReasonsWithKeys" [value]="reson.key">
                    {{reson.display}}</option>
                </select>
 
              </div>
            </div>
          </div>
 
        </form>
 
      </div>
      <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closeModelPopup('showTerminateMemberDetails')">
          {{lang.Cancel}}
        </button>
        <button class="text-end" type="submit" class="btn btn-primary personalinfobutton"
          (click)="submitterminationEnd_v2()">
          {{lang.Terminate}}&nbsp;&nbsp;
        </button>
 
      </div>
    </div>
  </div>
</div>
 
 
 
 